import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["accountByUser", "accountRoleByUser"];

  onChange() {
    const accountId = this.accountByUserTarget.value;

    Rails.ajax({
      type: "get",
      url: `/admin/accounts/${accountId}/roles.json`,
      success: (data) => {
        this.refreshDropdownValues(data);
      }
    });
  }

  refreshDropdownValues(data) {
    this.accountRoleByUserTarget.innerHTML = "";
    if (data.length > 0) {
      this.buildOption(null, "");
      data.forEach((role) => {
        this.buildOption(role.id, role.name);
      });
    }
  }

  buildOption(roleId, label) {
    const option = document.createElement("option");
    option.value = roleId;
    option.innerHTML = label;
    this.accountRoleByUserTarget.appendChild(option);
  }
}
